<template>
  <div class="comments">
    <slot></slot>
    <div v-for="(tableClass, index) in classes" :key="index">
      <div v-if="tableClass === 'expired'" class="link pointer" @click="navigateExternal()">
        > Shop (o.ä.) <i class="bi bi-box-arrow-up-right"></i>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { DisplayColumn } from '@/interfaces'
import { defineComponent, PropType } from 'vue'

export default defineComponent({
  name: 'ExternalLink',
  props: {
    classes: {
      type: Array as PropType<DisplayColumn['class']>,
      required: true,
    },
  },
  setup() {
    const fruitcoreShopLink = process.env.VUE_APP_FRUITCORE_ROBOTICS_SHOP
    const navigateExternal = () => {
      window.open(fruitcoreShopLink, '_blank')
    }

    return {
      navigateExternal,
    }
  },
})
</script>

<style lang="scss" scoped>
.comments {
  display: table-cell;
}

.link {
  color: $lighter-petrol;
}
</style>
